import { render } from "./Index.vue?vue&type=template&id=c108de76&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=c108de76&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c108de76"]])

export default __exports__